/* Koszyk Futrilo — sterowanie szufladą koszyka. Zwykły skrypt, bez importmapy,
   dzięki czemu działa też w uproszczonym layoucie koltunek.liquid.

   TRYB SKLEPU JEDNOPRODUKTOWEGO: kliknięcie w przycisk zakupu (buy box oraz
   pasek CTA) dodaje wariant do koszyka i przenosi od razu na ekran płatności,
   z pominięciem szuflady koszyka. Szuflada nadal działa dla ikony koszyka. */
(function () {
  'use strict';

  var SECTION = 'futrilo-cart';
  var TIMER_KEY = 'futrilo_cart_deadline';
  var TIMER_MS = 5 * 60 * 1000;
  var CHECKOUT_URL = '/checkout';

  var deadline = 0;
  var ticker = null;
  var pending = false;

  function root() {
    return document.getElementById('FutriloCart');
  }

  function host() {
    return document.getElementById('shopify-section-' + SECTION);
  }

  function itemCount() {
    var b = document.querySelector('.fc-body');
    return b ? parseInt(b.getAttribute('data-fc-count') || '0', 10) : 0;
  }

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    var add = r.cart_add_url || '/cart/add';
    var change = r.cart_change_url || '/cart/change';
    if (!/\.js$/.test(add)) add += '.js';
    if (!/\.js$/.test(change)) change += '.js';
    return { add: add, change: change };
  }

  /* ---------- otwieranie / zamykanie ---------- */

  function open() {
    var r = root();
    if (!r) return;
    r.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    syncTimer();
  }

  function close() {
    var r = root();
    if (!r) return;
    r.removeAttribute('data-open');
    document.body.style.overflow = '';
  }

  /* ---------- pasek rezerwacji ---------- */

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function setDeadline(force) {
    var stored = 0;
    try {
      stored = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10);
    } catch (e) {}
    if (force || !stored || stored <= Date.now()) {
      stored = Date.now() + TIMER_MS;
      try {
        sessionStorage.setItem(TIMER_KEY, String(stored));
      } catch (e) {}
    }
    deadline = stored;
  }

  function tick() {
    var r = root();
    var clock = r && r.querySelector('[data-fc-clock]');
    if (!clock) return;
    var left = deadline - Date.now();
    if (left <= 0) {
      setDeadline(true);
      left = deadline - Date.now();
    }
    var s = Math.floor(left / 1000);
    clock.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
  }

  function syncTimer() {
    var r = root();
    var bar = r && r.querySelector('[data-fc-timer]');
    if (!bar) return;

    if (itemCount() < 1) {
      bar.hidden = true;
      if (ticker) {
        clearInterval(ticker);
        ticker = null;
      }
      return;
    }

    bar.hidden = false;
    if (ticker) return;
    setDeadline(false);
    tick();
    ticker = setInterval(tick, 1000);
  }

  /* ---------- render ---------- */

  function applyHtml(html) {
    var h = host();
    if (!h || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var inner = parsed.getElementById('shopify-section-' + SECTION);
    h.innerHTML = inner ? inner.innerHTML : html;
    syncBubble();
    syncTimer();
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION, {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        applyHtml(data[SECTION]);
      })
      .catch(function () {});
  }

  function syncBubble() {
    var count = itemCount();
    Array.prototype.forEach.call(document.querySelectorAll('[ref="cartBubbleCount"]'), function (n) {
      n.textContent = String(count);
      n.classList.toggle('hidden', count === 0);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[ref="cartBubble"]'), function (n) {
      n.classList.toggle('visually-hidden', count === 0);
    });
  }

  /* ---------- operacje na koszyku ---------- */

  function send(url, options) {
    if (pending) return Promise.resolve();
    pending = true;
    var r = root();
    if (r) r.setAttribute('data-busy', '');

    return fetch(url, options)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION]) {
          applyHtml(data.sections[SECTION]);
          return null;
        }
        return refresh();
      })
      .catch(function () {
        return refresh();
      })
      .then(function () {
        pending = false;
        var rr = root();
        if (rr) rr.removeAttribute('data-busy');
      });
  }

  function postJson(url, payload) {
    payload.sections = SECTION;
    payload.sections_url = window.location.pathname;
    return send(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function change(id, quantity) {
    return postJson(routes().change, { id: id, quantity: quantity });
  }

  function add(id, quantity) {
    return postJson(routes().add, { items: [{ id: id, quantity: quantity || 1 }] });
  }

  function addForm(form) {
    var data = new FormData(form);
    data.append('sections', SECTION);
    data.append('sections_url', window.location.pathname);
    return send(routes().add, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    });
  }

  /* ---------- zakup jednym kliknięciem ---------- */

  function busy(on) {
    pending = on;
    var r = root();
    if (r) {
      if (on) r.setAttribute('data-busy', '');
      else r.removeAttribute('data-busy');
    }
  }

  function fallbackToDrawer() {
    busy(false);
    open();
    return refresh();
  }

  function directCheckout(body, headers) {
    if (pending) return Promise.resolve();
    busy(true);
    return fetch(routes().add, { method: 'POST', headers: headers, body: body })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        window.location.href = CHECKOUT_URL;
      })
      .catch(fallbackToDrawer);
  }

  function buyNow(id, quantity) {
    return directCheckout(
      JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] }),
      { 'Content-Type': 'application/json', Accept: 'application/json' }
    );
  }

  function buyNowForm(form) {
    return directCheckout(new FormData(form), { Accept: 'application/json' });
  }

  /* ---------- zdarzenia ---------- */

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;

      var inDrawer = target.closest('#FutriloCart');

      if (!inDrawer) {
        var atc = target.closest('[data-kt-atc]');
        if (atc) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var variantId = atc.getAttribute('data-kt-id');
          if (!variantId || variantId === '0') return;
          buyNow(variantId, 1);
          return;
        }

        var opener = target.closest('[data-fc-open], a[href$="/cart"], [on\\:click^="#cart-drawer"]');
        if (opener) {
          e.preventDefault();
          e.stopImmediatePropagation();
          open();
          refresh();
          return;
        }
      }

      if (target.closest('[data-fc-close]')) {
        e.preventDefault();
        close();
        return;
      }

      var qty = target.closest('[data-fc-qty]');
      if (qty) {
        e.preventDefault();
        change(qty.getAttribute('data-fc-qty'), parseInt(qty.getAttribute('data-fc-to'), 10));
        return;
      }

      var remove = target.closest('[data-fc-remove]');
      if (remove) {
        e.preventDefault();
        change(remove.getAttribute('data-fc-remove'), 0);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buyNowForm(form);
    },
    true
  );

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || typeof input.closest !== 'function') return;
    var toggle = input.closest('[data-fc-upsell]');
    if (!toggle) return;

    if (toggle.checked) {
      add(toggle.getAttribute('data-fc-variant'), 1);
    } else {
      var key = toggle.getAttribute('data-fc-key');
      if (key) change(key, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var r = root();
    if (r && r.hasAttribute('data-open')) close();
  });

  /* Zapasowa ścieżka: gdy koszyk zmieni inny skrypt motywu. */
  ['cart:lines-update', 'cart:update'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (pending) return;
      refresh();
    });
  });

  document.addEventListener('DOMContentLoaded', syncBubble);

  window.FutriloCart = {
    open: open,
    close: close,
    add: add,
    change: change,
    refresh: refresh,
    buyNow: buyNow
  };
})();
